import React from "react";
import {
  ShieldCheck,
  MousePointerClick,
  Truck,
  ClipboardList,
} from "lucide-react";
import FrequentlyBooked from "./Frequnatly";

const features = [
  {
    icon: ShieldCheck,
    title: "100% Safe & Secure",
    desc: "We take all safety and hygiene measures to keep our customers safe.",
  },
  {
    icon: MousePointerClick,
    title: "Click and Pick",
    desc: "Click to buy a range of products across categories",
  },
  {
    icon: Truck,
    title: "Home Delivery",
    desc: "We offer convenient home delivery of medicines & general goods",
  },
  {
    icon: ClipboardList,
    title: "Unlimited Health Records",
    desc: "Save all your health records (Medical Records...)",
  },
];

const WhyCosmicCareness = () => {
  return (

    <>
      <section className="w-full bg-[#FAFAFA] py-12">
        <div className="max-w-7xl mx-auto px-4">

          {/* Heading */}
          <h2 className="text-[24px] md:text-[30px] font-medium text-black mb-8">
            Why Cosmic Careness?
          </h2>

          {/* ✅ MOBILE SLIDER */}
          <div className="flex gap-6 overflow-x-auto md:hidden no-scrollbar pb-2">
            {features.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="min-w-[240px] bg-transparent flex-shrink-0"
                >
                  <div className="flex flex-col gap-4">
                    <div className="w-[55px] h-[55px] rounded-full border-2 border-[#187685] flex items-center justify-center bg-white">
                      <Icon size={26} className="text-[#187685]" />
                    </div>

                    <h3 className="text-[15px] font-semibold text-[#187685]">
                      {item.title}
                    </h3>

                    <p className="text-[13px] leading-[20px] text-[#060A0B]">
                      {item.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ✅ DESKTOP / TABLET GRID */}
          <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-10">
            {features.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="flex flex-col gap-4">
                  <div className="w-[55px] h-[55px] rounded-full border-2 border-[#187685] flex items-center justify-center bg-white">
                    <Icon size={26} className="text-[#187685]" />
                  </div>

                  <h3 className="text-[15px] font-semibold text-[#187685]">
                    {item.title}
                  </h3>

                  <p className="text-[13px] leading-[20px] text-[#060A0B]">
                    {item.desc}
                  </p>
                </div>
              );
            })}
          </div>

        </div>
      </section>
      <FrequentlyBooked/>
    </>
  );
};

export default WhyCosmicCareness;
